import { render } from "./portfolioUpload.vue?vue&type=template&id=ee230b0a"
import script from "./portfolioUpload.vue?vue&type=script&lang=js"
export * from "./portfolioUpload.vue?vue&type=script&lang=js"

import "./portfolioUpload.vue?vue&type=style&index=0&id=ee230b0a&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__